// A helper function for staggering animations ensuring items in longer lists will have faster animating items to arrive at the same total animation time as shorter lists.

// It takes an index and the length of the list and for each item in the list it returns a delay that is a fraction of the total animation time. The delay is calculated so that the total animation time is always the same, regardless of the length of the list, while also keeping a maximum delay for each item.

export const calculateStaggerDelay = (index: number, listLength: number) => {
    const maxTotalDelay = 0.4; // Total delay for all items in seconds, fixed to ensure consistency
    const maxIndividualDelay = 0.1; // Maximum delay for each item in seconds, fixed to ensure consistency

    // Calculate the delay per item to keep total stagger time within maxTotalDelay
    let delayPerItem = maxTotalDelay / listLength;

    // Ensure the delay per item does not exceed maxIndividualDelay
    delayPerItem = Math.min(delayPerItem, maxIndividualDelay);

    // Calculate the delay for the current item
    const delay = delayPerItem * index;

    return delay;
};
